import { render, staticRenderFns } from "./MarqiiHeader.vue?vue&type=template&id=488dbc72"
import script from "./MarqiiHeader.vue?vue&type=script&lang=js"
export * from "./MarqiiHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports